import placeResultAdapter from './place-result-adapter';

let placesService;

/**
 * Retrieves place details from Google Places API.
 *
 * Reference: https://developers.google.com/maps/documentation/javascript/places#place_details_requests
 */
export default function fetchPlacePredictions(placeId) {
    if (!window.google || !window.google.maps) {
        return Promise.resolve(null);
    } else if (!placesService) {
        const dummyDiv = document.createElement('div'); // PlacesService throws an error if you don't pass in a div
        placesService = new window.google.maps.places.PlacesService(dummyDiv);
    }

    return new Promise(resolve => {
        placesService.getDetails({ placeId }, (place, status) =>
            resolve(status === window.google.maps.places.PlacesServiceStatus.OK ?
                placeResultAdapter(place) :
                null));
    });
}
